import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Tabs, TabsButton } from '../../../../../components/Tabs';
import { ModalSteps } from '../../../constants';
import styles from './Menu.module.scss';
const Menu = ({ selectedValue, onChange }) => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: _jsxs(Tabs, Object.assign({ selectedTabValue: selectedValue, onChange: (value) => onChange(value), fullWidth: true, theme: "light" }, { children: [_jsx(TabsButton, Object.assign({ value: ModalSteps.LOGIN, "data-cy": "authentication-modal-menu-login" }, { children: t('authentication.menu.login') })), _jsx(TabsButton, Object.assign({ value: ModalSteps.USER_INFO, "data-cy": "authentication-modal-menu-signup" }, { children: t('authentication.menu.signup') }))] })) })));
};
export default Menu;
